module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/5303bee7054e79776230d794d4cb47de.svg";